import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserSignature } from '@/hooks/use-signature';

interface CreatorSignatureProps {
  signature: UserSignature;
}

export const CreatorSignature: React.FC<CreatorSignatureProps> = ({ signature }) => {
  const navigate = useNavigate();

  if (!signature?.enabled) {
    return null;
  }

  return (
    <div className="mt-4">
      <div className="flex items-center mb-2">
        <h4 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-300/80">
          Creator signature
        </h4>
        <span className="flex-1 ml-3 h-px bg-white/10" />
      </div>
      
      {signature.link_url ? (
        <button
          className="group w-full overflow-hidden rounded-2xl bg-[#0F0F10] ring-1 ring-white/5 hover:ring-purple-500/30 hover:shadow-[0_10px_30px_-10px_rgba(168,85,247,0.35)] transition-all duration-200"
          onClick={() => navigate(`/leaving?to=${encodeURIComponent(signature.link_url || '')}`)}
          aria-label="Open creator link"
        >
          <div className="w-full aspect-[16/9]">
            <img 
              src={signature.image_url} 
              alt="Creator signature" 
              className="w-full h-full object-cover scale-[1.01] group-hover:scale-105 transition-transform duration-300" 
            />
          </div>
        </button>
      ) : (
        <div className="w-full overflow-hidden rounded-2xl bg-[#0F0F10] ring-1 ring-white/5">
          <div className="w-full aspect-[16/9]">
            <img 
              src={signature.image_url} 
              alt="Creator signature" 
              className="w-full h-full object-cover" 
            />
          </div>
        </div>
      )}
    </div>
  );
};